import graphql__9fd0c44d19e968a75a5c from "./__generated__/InitiateInvoicePaymentDialog_invoice.graphql.ts";
import graphql__d04b31328c6c6c309c4c from "./__generated__/InitiateInvoicePaymentDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useIntl} from "react-intl";

type InitiateInvoicePaymentDialogProps = {
    queryRef: any,
    handleCloseDialog: () => {}
}

const InitiateInvoicePaymentDialog: React.FC<InitiateInvoicePaymentDialogProps> = (props) => {

    const intl = useIntl();
    const invoice = useFragment(
        graphql__9fd0c44d19e968a75a5c,
        props.queryRef
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__d04b31328c6c6c309c4c,
                variables: {
                    input: input
                },
                onCompleted: () => {
                    props.handleCloseDialog();
                },
                onError: () => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToInitiatePayment'})
            }
        )
    }

    const initialValues = {
        invoiceIdentifier: invoice.id
    }

    const currentPaymentMethodDescription = invoice.paymentMethod.paymentMethodType === 'SepaDebit' ?
        intl.formatMessage({id: 'paymentMethod.SepaDebit.description'}, {lastFourDigits: invoice.paymentMethod.lastFourDigits})
        : invoice.paymentMethod.paymentMethodType === 'Card' ?
            intl.formatMessage({id: 'paymentMethod.Card.description'}, {
                cardBrand: invoice.paymentMethod.cardBrand,
                lastFourDigits: invoice.paymentMethod.lastFourDigits
            })
            : invoice.paymentMethod.paymentMethodType

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    headline={intl.formatMessage({id: 'dialog.InitiateInvoicePaymentDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'dialog.InitiateInvoicePaymentDialog.submitLabel'})}>
            <Section>
                <Row>
                    <div className="text-gray-900">
                        <p>{intl.formatMessage({id: 'dialog.InitiateInvoicePaymentDialog.description'}, {
                            number: invoice.invoiceNumber,
                            paymentMethod: currentPaymentMethodDescription
                        })}</p>
                    </div>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default InitiateInvoicePaymentDialog;
